<template>
  <el-drawer :visible.sync="localVisible" direction="rtl" :before-close="handleClose" :append-to-body="true"
    :size="screenWidth < 768 ? '100%' : '500px'" :show-close="false" custom-class="address-drawer"
    :wrapperClosable="false" :with-header="false">
    <div class="drawer-header">
      <div class="drawer-title">{{ isEdit ? 'EDIT ADDRESS' : 'ADD NEW ADDRESS' }}</div>
      <button class="close-btn" @click="handleClose(0)"><i class="el-icon-close"></i></button>
    </div>

    <div class="drawer-body" :style="{ padding: isEdit ? '0px 20px 40px' : '80px 20px 40px' }">
      <el-form ref="addressForm" :model="form" :rules="rules" label-position="top" class="custom-form"
        hide-required-asterisk :style="{ paddingTop: isEdit ? '0px' : '20px' }">
        <!-- 姓名行 -->
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="First Name">
              <el-input v-model="form.firstName" placeholder="First Name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Last Name" prop="lastName">
              <el-input v-model="form.lastName" placeholder="Last Name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 国家 -->
        <el-form-item label="Country" prop="countryId">
          <el-select v-model="form.countryId" placeholder="Select Country" style="width: 100%;"
            @change="handleCountryChange" :no-data-text="'No Data Found'">
            <el-option v-for="item in CountryList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 街道地址 -->
        <el-form-item label="Street Address" prop="address">
          <el-input v-model="form.address" placeholder="Street Address"></el-input>
        </el-form-item>

        <!-- 公寓/楼层 (选填) -->
        <el-form-item label="Apt, Floor, Suite, Etc.(optional)" prop="apt">
          <el-input v-model="form.apt" placeholder="Apt, Floor, Suite, Etc.(optional)"></el-input>
        </el-form-item>

        <!-- 城市 -->
        <el-form-item label="City" prop="city">
          <el-input v-model="form.city" placeholder="City"></el-input>
        </el-form-item>

        <!-- 州和邮编 -->
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="State">
              <el-select v-model="form.stateId" placeholder="Select State" style="width: 100%;"
                @change="handleStateChange" :no-data-text="'No Data Found'">
                <el-option v-for="item in StateList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Postal Code" prop="postCode">
              <el-input v-model="form.postCode" placeholder="Postal Code"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 电话 -->
        <el-form-item label="Phone" prop="phone">
          <el-input v-model="form.phone" placeholder="Phone"></el-input>
        </el-form-item>

        <!-- 设为默认 -->
        <el-form-item class="checkbox-item">
          <el-checkbox v-model="form.defaultFlag" :true-label="1" :false-label="0">Set as default</el-checkbox>
        </el-form-item>

        <!-- 底部按钮 -->
        <div class="form-footer">
          <el-button type="primary" class="save-btn" :loading="loading" @click="submitForm">
            {{ isEdit ? 'UPDATE ADDRESS' : 'SAVE ADDRESS' }}
          </el-button>
          <div class="cancel-link" @click="handleClose(0)">CANCEL</div>
        </div>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import { addUserAddress, getCountryAddressList, getStatesAddressList } from '@/api/member';

// 定义默认表单数据，方便重置
const defaultForm = {
  wdId: null, // 增加 ID 字段用于区分编辑状态
  firstName: '',
  lastName: '',
  phone: '',
  address: '',
  country: '',
  apt: '',
  city: '',
  state: '',
  postCode: '',
  countryId: '',
  stateId: '',
  defaultFlag: 0
};

export default {
  name: 'AddAddressDrawer',
  props: ['visible', 'EditData'],
  data() {
    return {
      loading: false,
      screenWidth: document.documentElement.clientWidth || window.innerWidth,
      form: { ...defaultForm },
      rules: {
        // firstName: [{ required: true, message: 'Required', trigger: 'blur' }],
        lastName: [{ required: true, message: 'Required', trigger: 'blur' }],
        countryId: [{ required: true, message: 'Required', trigger: 'change' }],
        address: [{ required: true, message: 'Required', trigger: 'blur' }],
        city: [{ required: true, message: 'Required', trigger: 'blur' }],
        // state: [{ required: true, message: 'Required', trigger: 'blur' }],
        postCode: [{ required: true, message: 'Required', trigger: 'blur' }],
        phone: [{ required: true, message: 'Required', trigger: 'blur' }]
      },
      //国家列表
      CountryList: [],
      StateList: []
    };
  },
  computed: {
    localVisible: {
      get() { return this.visible; },
      set(val) { this.$emit('update:visible', val); }
    },
    isEdit() {
      return !!this.form.wdId;
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  watch: {
    visible(val) {
      if (val) {
        this.initFormData();
      } else {
        this.$nextTick(() => {
          this.$refs.addressForm.clearValidate();
        });
      }
    }
  },
  methods: {
    initFormData() {
      this.getCountryList()
      if (this.EditData) {
        try {
          const data = typeof this.EditData === 'string'
            ? JSON.parse(this.EditData)
            : this.EditData;

          this.form = { ...defaultForm, ...data };
          //获取默认地址
          this.getStateList(data.countryId)

        } catch (e) {
          console.error("解析 EditData 失败:", e);
          this.form = { ...defaultForm };
        }
      } else {
        this.form = { ...defaultForm };
      }
    },
    handleResize() {
      this.screenWidth = document.documentElement.clientWidth || window.innerWidth;
    },
    handleClose(type) {
      this.localVisible = false;
      this.$emit('closeHandler', { type: type });
    },
    submitForm() {
      this.$refs.addressForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          addUserAddress(this.form).then(res => {
            if (res.code == 1) {
              this.$message.success(this.isEdit ? 'Updated successfully' : 'Added successfully');
              this.localVisible = false;
              this.$emit('closeHandler', res.data.dateDetails);
            } else {
              this.$message.error(res.message || 'Operation failed');
            }
          }).catch(err => {
            console.error(err);
            this.$message.error('Network Error');
          }).finally(() => {
            this.loading = false;
          });
        } else {
          return false;
        }
      });
    },
    //国家改变时，状态列表也会改变
    handleCountryChange(item) {
      this.form.country = this.CountryList.find(country => country.id == item).name
      this.getStateList(item)
    },
    //国家
    getCountryList() {
      getCountryAddressList().then(res => {
        if (res.code == 1) {
          this.CountryList = res.data.dataList
        }
      })
    },
    getStateList(item) {
      getStatesAddressList({ countryId: item }).then(res => {
        if (res.code == 1) {
          this.StateList = res.data.dataList
        }
      })
    },
    handleStateChange(item) {
      this.form.state = this.StateList.find(state => state.id == item).name
    }
  }
};
</script>

<style lang="scss">
/* 保持原有样式不变 */
::v-deep .el-range-editor.is-active,
::v-deep .el-range-editor.is-active:hover,
::v-deep .el-select .el-input.is-focus .el-input__inner {
  border-color: #2B231E;
}

.el-select .el-input.is-focus .el-input__inner {
  border-color: #2B231E;
}

.address-drawer {
  font-family: "NotoSerif", sans-serif;
  outline: none;

  .el-drawer__body {
    padding: 0;
    overflow-y: auto;
  }
}

.drawer-header {
  padding: 30px 20px 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .drawer-title {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #333;
    text-transform: uppercase;
  }

  .close-btn {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #999;

    &:hover {
      color: #333;
    }
  }
}

.drawer-body {
  // padding: 0px 20px 40px !important;
}

.custom-form {
  margin-top: 10px;

  .el-form-item {
    margin-bottom: 25px;
    position: relative;
  }

  .el-form-item__label {
    position: absolute;
    top: 0;
    left: 12px;
    transform: translateY(-50%);
    background-color: #fff;
    padding: 0 5px;
    z-index: 2;
    line-height: 1;
    font-size: 13px;
    color: #333;
    font-weight: bold;
    font-family: "NotoSerif", serif;
  }

  .el-input__inner {
    border-radius: 4px;
    border-color: #e0e0e0;
    height: 45px;
    padding-left: 15px;

    &:focus {
      border-color: #a0a0a0;
    }
  }

  input::placeholder {
    color: #C9CDD4;
    font-family: "NotoSerif", serif;
    opacity: 0.5;
  }

  .checkbox-item {
    margin-top: 10px;
    margin-bottom: 30px;

    .el-checkbox__label {
      font-family: "NotoSerif", serif;
      color: #333;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #5D4E46;
      border-color: #5D4E46;
    }
  }

  .form-footer {
    text-align: center;

    .save-btn {
      width: 100%;
      background-color: #5D4E46;
      border-color: #5D4E46;
      border-radius: 2px;
      color: #fff;
      font-family: "NotoSerif", serif;
      letter-spacing: 1px;
      padding: 15px 0;
      text-transform: uppercase;
      font-weight: bold;

      &:hover {
        background-color: #4a3e38;
      }
    }

    .cancel-link {
      margin-top: 20px;
      cursor: pointer;
      text-decoration: underline;
      font-size: 14px;
      color: #333;
      text-transform: uppercase;
      font-weight: bold;
      letter-spacing: 1px;
    }
  }
}

@media (max-width: 768px) {
  .drawer-header {
    height: 10rem !important;
  }

  .drawer-body {
    padding-top: 10rem !important;
    width: 94%;
  }

  .custom-form .el-form-item__label,.drawer-title,.cancel-link {
    font-size: 4rem !important;
  }
.custom-form .el-input__inner {
    height: 10rem !important;
  }
  .el-form-item {
    margin-bottom: 10rem !important;
  }
}

@media (max-width: 768px){
  .drawer-body {
  padding: 80px 20px 40px !important;
}
} 
</style>